import { render, staticRenderFns } from "./preview-address-detail.vue?vue&type=template&id=42cc386a&"
import script from "./preview-address-detail.vue?vue&type=script&lang=js&"
export * from "./preview-address-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports